import './widget.css';

export function Widget(props) {
    const className = props.class ? props.class : "";
    const noMargins = props.noMargins ? "no-margins" : "";
    const centered = props.centered ? "centered" : "";
    const variant = props.variant ? props.variant : "";

    return (
        <div className={`widget ${className} ${noMargins} ${centered}`} variant={variant}>
            {props.children}
        </div>
    );
}